import { Dropdown, Option, OptionOnSelectData, SelectionEvents } from "@fluentui/react-components";
import { FunctionComponent } from "react";

export type ChatModeType = 'project' | 'legislation';

interface ChatModeDropdownProps {
  mode: ChatModeType;
  onModeSelected: (ev: SelectionEvents, data: OptionOnSelectData) => void;
}

export const ChatModeDropdown: FunctionComponent<ChatModeDropdownProps> = ({ mode, onModeSelected }) => {
  return (
    <>
      <div className="chat-mode">Mode: &nbsp;</div>
      <Dropdown 
        size='small' 
        value={mode === 'project' ? 'BIM only' : 'BIM + Legislation'} 
        selectedOptions={[mode]} 
        className="dropdown-chat-mode" 
        onOptionSelect={onModeSelected}
      >
        <Option key="project" text="BIM only" value="project">
          <span className="dropdown-item">BIM only</span>
        </Option>
        <Option key="legislation" text="BIM + Legislation" value="legislation">
          <span className="dropdown-item">BIM + Legislation</span>
        </Option>
      </Dropdown>
    </>
  );
}

export default ChatModeDropdown;
